export const CITY_ERROR_MESSAGE = 'Enter a valid city (at least 2 characters)'

export function normalizeCityInput(raw) {
  return String(raw ?? '')
    .trim()
    .replace(/\s+/g, ' ')
}

export function isValidCity(value) {
  return normalizeCityInput(value).length >= 2
}
